export default "__VITE_ASSET__FAwF3d1u__"